/**
 * Clipboard port — web implementation.
 *
 * Reads need an explicit permission grant and are unavailable in Firefox, so
 * read failures resolve empty rather than throwing.
 */
export const setClipboardString = (text: string): void => {
  navigator?.clipboard?.writeText?.(text).catch((error: unknown) => {
    console.warn('[Clipboard] write failed:', error);
  });
};

export const getClipboardString = async (): Promise<string> => {
  try {
    return (await navigator?.clipboard?.readText?.()) ?? '';
  } catch (error) {
    console.warn('[Clipboard] read failed:', error);
    return '';
  }
};

export const hasClipboardString = async (): Promise<boolean> =>
  (await getClipboardString()).length > 0;
